<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps<{
	logoUrl: string;
	title: string;
	description: string;
}>();

const logoFailed = ref(false);

watch(() => props.logoUrl, () => {
	logoFailed.value = false;
});
</script>

<template>
	<article class="game-hero">
		<img
			v-if="logoUrl && !logoFailed"
			class="game-hero-logo"
			:src="logoUrl"
			:alt="`${title} logo`"
			@error="logoFailed = true"
		>
		<h1>{{ title }}</h1>
		<p v-if="description">{{ description }}</p>
	</article>
</template>
